var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-download-box w-full h-full p-4 box-border overflow-hidden"},[_c('div',{staticClass:"card h-full p-5 box-border bg-white shadow-theme rounded"},[_c('div',{staticClass:"card-body h-full overflow-hiddle box-border"},[_c('AllDownload')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }